import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class portalService {
    /******* QUERIES ******/
    
    async enviarCorreoPortal(data) {
        const response = await axios
            .post(`${ERP}integracion/portal`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async pdfA4(filter) {
        
        const response = await axios
            .get(`${ERP}integracion/portal/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async xml(filter) {
        const response = await axios
            .get(`${ERP}integracion/portal/xml?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new portalService();